<template>
  <div v-if="fiscalTaxParameter.ratesVisible">
    <b-row>
      <b-col md="3">
        <FormulateInput
          id="tax-parameter-cbs-percent"
          v-model="fiscalTaxParameter.cbsPercent"
          name="tax-parameter-cbs-percent"
          type="text-percetage"
          currency="%"
          :precision="5"
          validation="required|number|min:0.0000|max:1"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
          :label="$t('FISCAL_TAX_PARAMETER.LABEL.CBS_PERCENT')"
          class="required"
        />
      </b-col>
      <b-col md="3">
        <FormulateInput
          id="tax-parameter-cbs-reduction-percent"
          v-model="fiscalTaxParameter.cbsReductionPercent"
          name="tax-parameter-cbs-reduction-percent"
          type="text-percetage"
          currency="%"
          :precision="5"
          validation="required|number|min:0.0000|max:1"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
          :label="$t('FISCAL_TAX_PARAMETER.LABEL.CBS_REDUCTION_PERCENT')"
          class="required"
        />
      </b-col>
      <b-col md="3">
        <FormulateInput
          id="tax-parameter-cbs-deferral-percent"
          v-model="fiscalTaxParameter.cbsDeferralPercent"
          name="tax-parameter-cbs-deferral-percent"
          type="text-percetage"
          currency="%"
          :precision="5"
          validation="required|number|min:0.0000|max:1"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
          :label="$t('FISCAL_TAX_PARAMETER.LABEL.CBS_DEFERRAL_PERCENT')"
          class="required"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { formulateHelper } from '@/mixins'
import { BRow, BCol } from 'bootstrap-vue'
import { mapState } from 'vuex'

export default {
  name: 'FiscalTaxParameterCbsForm',
  components: { BRow, BCol },
  mixins: [formulateHelper],
  computed: {
    ...mapState('pages/invoice/fiscalTaxParameters/fiscalTaxParameterMaintain', [
      'fiscalTaxParameter',
    ]),
  },
}
</script>
